module.exports = __webpack_public_path__ + "media/images/phone/story-script_tap-bg@2x-ffcde8e6a8d5417d3465c7187433a170.png";